import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../../helpers';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { store } from '../../../../../store/store';
import AclContextProvider from '../../../../Acl/Components/AclContextProvider';
import CaseTypeDetailButton from './CaseTypeDetailButton';
import { parseBoolean } from '../../../../../Utils/form.util';

loadDOMComponent({
	selector: 'react-manager-case-type-detail-button',
	callback: ({ container, context, props }: any) => {
		const workplaceId = container.getAttribute('workplaceId');
		const caseTypeId = container.getAttribute('caseTypeId');
		const isOnlyOneRoot = parseBoolean(container.getAttribute('isOnlyOneRoot'));

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<CaseTypeDetailButton
							workplaceId={workplaceId}
							caseTypeId={caseTypeId}
							isOnlyOneRoot={isOnlyOneRoot}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
